// 共通定数
import { MyConfig as mc } from '@/MyConfig'
// AXIOSモジュール
import Axios from 'axios'
// AWSモジュール
import * as Aws from 'aws-sdk'

/* *************************************************************************************************
 * クラス MyData
 *   下記データソースに対する処理をまとめたもの
 *   - メインデータ : API Gateway→Lamnba→DynamoDB
 *   - 画像データ   : S3
 * ********************************************************************************************** */
class MyData {
  /* ===================================================================================
   * コンストラクタ
   * ================================================================================ */
  constructor () {
    // 定数値をセット
    this.setupRemoteData()
  }

  /* ===================================================================================
   * メソッド setupRemoteData
   *   Axiosモジュールを設定し、本クラス内で共通利用
   *   オブジェクト名はremoteData
   * ================================================================================ */
  setupRemoteData () {
    mc.LOG_LEVEL ? console.log('%c info: Module=MyData.setupRemoteData: Start', mc.LOG_TYPE_I) : (() => { })()
    this.remoteData = Axios.create({
      baseURL: mc.API_BASE_URL,
      // ヘッダー付与
      // headers: {
      //   'Content-Type': 'application/json',
      //   'Content-Type': 'multipart/form-data',
      //   'X-Custom-XXX': 'YYY'
      // },
      // URLパラメーター
      // params: {
      //   foo: 1,
      //   bar: 2
      // },
      // 正常とみなすステータスコード
      // validateStatus: status => (status >= 200 && status < 300) || status == 404,
      // Basic認証
      // auth: {
      //   username: 'sato',
      //   password: 'pass'
      // },
      // プロキシ指定
      // proxy: {
      //   host: '127.0.0.1',
      //   port: 9000,
      //   auth: {
      //     username: 'hogehoge',
      //     password: 'fugafuga'
      //   }
      // }
      timeout: mc.API_TIMEOUT
    })
    mc.LOG_LEVEL ? console.log('%c info: Module=MyData.setupRemoteData: End', mc.LOG_TYPE_I) : (() => { })()
  }

  /* ===================================================================================
   * メソッド readMainData
   *   API Gatewayにアクセスしてメインデータを取得
   * ================================================================================ */
  async readMainData (idToken) {
    mc.LOG_LEVEL ? console.log('%c info: Module=MyData.readMainData: Start', mc.LOG_TYPE_I) : (() => { })()
    // 非同期をわかりやすくするため待つ
    // await new Promise(resolve => setTimeout(resolve, 2000))
    try {
      // API Gatewayにアクセスしてデータを取得、その内容をレスポンス
      const res = await this.remoteData.get(mc.API_MAINDATA_PATH, { headers: { Authorization: 'Bearer ' + idToken } })
      if (res.status === 200 && res.data.Count === 0) {
        mc.LOG_LEVEL ? console.log('%c info: Module=MyData.readMainData: NODATA', mc.LOG_TYPE_I) : (() => { })()
        return { status: 'NODATA' }
      } else if (res.status === 200 && res.data.Count !== 0) {
        mc.LOG_LEVEL ? console.log('%c info: Module=MyData.readMainData: OK: Count:', mc.LOG_TYPE_I, res.data.Count) : (() => { })()
        return { status: 'OK', content: res }
      }
    // 例外エラーが発生した場合、そのままthrow
    } catch (e) {
      mc.LOG_LEVEL ? console.log('%c error: Module=MyData.readMainData: ERROR:', mc.LOG_TYPE_E, e) : (() => { })()
      throw new Error(e)
    }
  }

  /* ===================================================================================
   * メソッド createMainData
   *   API Gatewayにアクセスしてメインデータを作成
   * ================================================================================ */
  async createMainData (idToken, itemForCreate) {
    mc.LOG_LEVEL ? console.log('%c info: Module=MyData.createMainData: Start', mc.LOG_TYPE_I) : (() => { })()
    // 非同期をわかりやすくするため2秒待つ
    // await new Promise(resolve => setTimeout(resolve, 2000))
    try {
      // API Gatewayにアクセスしてデータ更新
      const res = await this.remoteData.post(mc.API_MAINDATA_PATH, JSON.stringify(itemForCreate), { headers: { Authorization: 'Bearer ' + idToken } })
      if (res.status === 200) {
        mc.LOG_LEVEL ? console.log('%c info: Module=MyData.createMainData: OK', mc.LOG_TYPE_I) : (() => { })()
        return { status: 'OK' }
      }
    // 例外エラーが発生した場合、そのままthrow
    } catch (e) {
      mc.LOG_LEVEL ? console.log('%c error: Module=MyData.createMainData: ERROR:', mc.LOG_TYPE_E, e) : (() => { })()
      throw new Error(e)
    }
  }

  /* ===================================================================================
   * メソッド deleteMainData
   *   API Gatewayにアクセスしてメインデータを削除
   * ================================================================================ */
  async deleteMainData (idToken, targetId) {
    mc.LOG_LEVEL ? console.log('%c info: Module=MyData.deleteMainData: Start', mc.LOG_TYPE_I) : (() => { })()
    // 非同期をわかりやすくするため2秒待つ
    // await new Promise(resolve => setTimeout(resolve, 2000))
    try {
      // API Gatewayにアクセスしてデータ削除
      const res = await this.remoteData.delete(`${mc.API_MAINDATA_PATH}/${targetId}`, { headers: { Authorization: 'Bearer ' + idToken } })
      if (res.status === 200) {
        mc.LOG_LEVEL ? console.log('%c info: Module=MyData.deleteMainData: OK', mc.LOG_TYPE_I) : (() => { })()
        return { status: 'OK' }
      }
    // 例外エラーが発生した場合、そのままthrow
    } catch (e) {
      mc.LOG_LEVEL ? console.log('%c error: Module=MyData.deleteMainData: ERROR:', mc.LOG_TYPE_E, e) : (() => { })()
      throw new Error(e)
    }
  }

  /* ===================================================================================
   * メソッド updateMainData
   *   API Gatewayにアクセスしてメインデータを更新
   * ================================================================================ */
  async updateMainData (idToken, targetId, itemForUpdate) {
    mc.LOG_LEVEL ? console.log('%c info: Module=MyData.updateMainData: Start', mc.LOG_TYPE_I) : (() => { })()
    // 非同期をわかりやすくするため2秒待つ
    // await new Promise(resolve => setTimeout(resolve, 2000))
    try {
      // API Gatewayにアクセスしてデータ更新
      const res = await this.remoteData.put(`${mc.API_MAINDATA_PATH}/${targetId}`, JSON.stringify(itemForUpdate), { headers: { Authorization: 'Bearer ' + idToken } })
      if (res.status === 200) {
        mc.LOG_LEVEL ? console.log('%c info: Module=MyData.updateMainData: OK', mc.LOG_TYPE_I) : (() => { })()
        return { status: 'OK' }
      }
    // 例外エラーが発生した場合、そのままthrow
    } catch (e) {
      mc.LOG_LEVEL ? console.log('%c error: Module=MyData.updateMainData: ERROR:', mc.LOG_TYPE_E, e) : (() => { })()
      throw new Error(e)
    }
  }

  /* ===================================================================================
   * メソッド readImageData
   *   S3にアクセスしてイメージデータを取得
   * ================================================================================ */
  async readImageData (idToken, targetId) {
    mc.LOG_LEVEL ? console.log('%c info: Module=MyData.readImageData: Start', mc.LOG_TYPE_I) : (() => { })()
    const s3Param = {
      Bucket: mc.AWS_S3_BUCKET_NAME,
      Key: `${mc.AWS_S3_BUCKET_DIR}${targetId}.png`
    }
    try {
      Aws.config.region = mc.AWS_REGION
      Aws.config.credentials = new Aws.CognitoIdentityCredentials({
        IdentityPoolId: mc.AWS_IDENTIRY_POOL_ID,
        Logins: {
          [`cognito-idp.${mc.AWS_REGION}.amazonaws.com/${mc.AWS_USER_POOL_ID}`]: idToken
        }
      })
      /*
      Aws.config.credentials.get(() => {
        console.log('accessKeyId:', Aws.config.credentials.accessKeyId)
        console.log('secretAccessKey:', Aws.config.credentials.secretAccessKey)
        console.log('sessionToken:', Aws.config.credentials.sessionToken)
      })
      */
      const s3 = new Aws.S3()
      const res = await s3.getObject(s3Param).promise()
      mc.LOG_LEVEL ? console.log('%c info: Module=MyData.readImageData: OK', mc.LOG_TYPE_I) : (() => { })()
      return { status: 'OK', content: res }
    // 例外エラーが発生した場合、そのままthrow
    } catch (e) {
      mc.LOG_LEVEL ? console.log('%c error: Module=MyData.readImageData: ERROR:', mc.LOG_TYPE_E, e) : (() => { })()
      throw new Error(e)
    }
  }

  /* ===================================================================================
   * メソッド deleteImageData
   *   S3にアクセスしてイメージデータを削除
   * ================================================================================ */
  async deleteImageData (idToken, targetId) {
    mc.LOG_LEVEL ? console.log('%c info: Module=MyData.deleteImageData: Start', mc.LOG_TYPE_I) : (() => { })()
    const s3Param = {
      Bucket: mc.AWS_S3_BUCKET_NAME,
      Key: `${mc.AWS_S3_BUCKET_DIR}${targetId}.png`
    }
    try {
      Aws.config.region = mc.AWS_REGION
      Aws.config.credentials = new Aws.CognitoIdentityCredentials({
        IdentityPoolId: mc.AWS_IDENTIRY_POOL_ID,
        Logins: {
          [`cognito-idp.${mc.AWS_REGION}.amazonaws.com/${mc.AWS_USER_POOL_ID}`]: idToken
        }
      })
      /*
      Aws.config.credentials.get(() => {
        console.log('accessKeyId:', Aws.config.credentials.accessKeyId)
        console.log('secretAccessKey:', Aws.config.credentials.secretAccessKey)
        console.log('sessionToken:', Aws.config.credentials.sessionToken)
      })
      */
      const s3 = new Aws.S3()
      await s3.deleteObject(s3Param).promise()
      mc.LOG_LEVEL ? console.log('%c info: Module=MyData.deleteImageData: OK', mc.LOG_TYPE_I) : (() => { })()
      return { status: 'OK' }
    // 例外エラーが発生した場合、そのままthrow
    } catch (e) {
      mc.LOG_LEVEL ? console.log('%c error: Module=MyData.deleteImageData: ERROR:', mc.LOG_TYPE_E, e) : (() => { })()
      throw new Error(e)
    }
  }

  /* ===================================================================================
   * メソッド updateImageData
   *   S3にアクセスして画像ファイル更新を実行する(上書き・新規作成も兼ねる)
   * ================================================================================ */
  async updateImageData (idToken, targetId, imageData) {
    mc.LOG_LEVEL ? console.log('%c info: Module=MyData.updateImageData: Start', mc.LOG_TYPE_I) : (() => { })()
    const s3Param = {
      Bucket: mc.AWS_S3_BUCKET_NAME,
      Key: `${mc.AWS_S3_BUCKET_DIR}${targetId}.png`,
      ContentType: 'image/png',
      Body: imageData
    }
    try {
      Aws.config.region = mc.AWS_REGION
      Aws.config.credentials = new Aws.CognitoIdentityCredentials({
        IdentityPoolId: mc.AWS_IDENTIRY_POOL_ID,
        Logins: {
          [`cognito-idp.${mc.AWS_REGION}.amazonaws.com/${mc.AWS_USER_POOL_ID}`]: idToken
        }
      })
      /*
      Aws.config.credentials.get(() => {
        console.log('accessKeyId:', Aws.config.credentials.accessKeyId)
        console.log('secretAccessKey:', Aws.config.credentials.secretAccessKey)
        console.log('sessionToken:', Aws.config.credentials.sessionToken)
      })
      */
      const s3 = new Aws.S3()
      await s3.upload(s3Param).promise()
      mc.LOG_LEVEL ? console.log('%c info: Module=MyData.updateImageData: OK', mc.LOG_TYPE_I) : (() => { })()
      return { status: 'OK' }
    // 例外エラーが発生した場合、そのままthrow
    } catch (e) {
      mc.LOG_LEVEL ? console.log('%c error: Module=MyData.updateImageData: ERROR:', mc.LOG_TYPE_E, e) : (() => { })()
      throw new Error(e)
    }
  }

  /* ===================================================================================
   * メソッド readTagData
   *   API Gatewayにアクセスしてメインデータを取得
   * ================================================================================ */
  async readTagData (idToken) {
    mc.LOG_LEVEL ? console.log('%c info: Module=MyData.readTagData: Start', mc.LOG_TYPE_I) : (() => { })()
    // 非同期をわかりやすくするため待つ
    // await new Promise(resolve => setTimeout(resolve, 2000))
    try {
      // API Gatewayにアクセスしてデータを取得、その内容をレスポンス
      const res = await this.remoteData.get(mc.API_TAGDATA_PATH, { headers: { Authorization: 'Bearer ' + idToken } })
      if (res.status === 200 && res.data.Count === 0) {
        mc.LOG_LEVEL ? console.log('%c info: Module=MyData.readTagData: NODATA', mc.LOG_TYPE_I) : (() => { })()
        return { status: 'NODATA' }
      } else if (res.status === 200 && res.data.Count !== 0) {
        mc.LOG_LEVEL ? console.log('%c info: Module=MyData.readTagData: OK: Count:', mc.LOG_TYPE_I, res.data.Count) : (() => { })()
        return { status: 'OK', content: res }
      }
      // 例外エラーが発生した場合、そのままthrow
    } catch (e) {
      mc.LOG_LEVEL ? console.log('%c error: Module=MyData.readTagData: ERROR:', mc.LOG_TYPE_E, e) : (() => { })()
      throw new Error(e)
    }
  }

  /* ===================================================================================
   * メソッド deleteTagData
   *   API Gatewayにアクセスしてタグデータを削除
   * ================================================================================ */
  async deleteTagData (idToken, itemForDelete) {
    mc.LOG_LEVEL ? console.log('%c info: Module=MyData.deleteTagData: Start', mc.LOG_TYPE_I) : (() => { })()
    // 非同期をわかりやすくするため2秒待つ
    // await new Promise(resolve => setTimeout(resolve, 2000))
    try {
      // API Gatewayにアクセスしてデータ削除
      const res = await this.remoteData.put(mc.API_TAGDATA_PATH, JSON.stringify(itemForDelete), { headers: { Authorization: 'Bearer ' + idToken } })
      if (res.status === 200) {
        mc.LOG_LEVEL ? console.log('%c info: Module=MyData.deleteTagData: OK', mc.LOG_TYPE_I) : (() => { })()
        return { status: 'OK' }
      }
      // 例外エラーが発生した場合、そのままthrow
    } catch (e) {
      mc.LOG_LEVEL ? console.log('%c error: Module=MyData.deleteTagData: ERROR:', mc.LOG_TYPE_E, e) : (() => { })()
      throw new Error(e)
    }
  }

  /* ===================================================================================
   * メソッド updateTagData
   *   API Gatewayにアクセスしてタグデータを更新
   * ================================================================================ */
  async updateTagData (idToken, itemForUpdate) {
    mc.LOG_LEVEL ? console.log('%c info: Module=MyData.updateTagData: Start', mc.LOG_TYPE_I) : (() => { })()
    // 非同期をわかりやすくするため2秒待つ
    // await new Promise(resolve => setTimeout(resolve, 2000))
    try {
      // API Gatewayにアクセスしてデータ更新
      const res = await this.remoteData.put(mc.API_TAGDATA_PATH, JSON.stringify(itemForUpdate), { headers: { Authorization: 'Bearer ' + idToken } })
      if (res.status === 200) {
        mc.LOG_LEVEL ? console.log('%c info: Module=MyData.updateTagData: OK', mc.LOG_TYPE_I) : (() => { })()
        return { status: 'OK' }
      }
      // 例外エラーが発生した場合、そのままthrow
    } catch (e) {
      mc.LOG_LEVEL ? console.log('%c error: Module=MyData.updateTagData: ERROR:', mc.LOG_TYPE_E, e) : (() => { })()
      throw new Error(e)
    }
  }
}
export { MyData }
